import { Trans } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";
import { observer } from "mobx-react-lite";
import { InvoiceTypeEnum, useInvoiceStore } from "../../../../store";

export const AlreadyInvoiced = observer(function AlreadyInvoiced() {
  const store = useInvoiceStore();
  return (
    <div className="flex items-center">
      <Icon name="check-circle" color="#637381" />
      <label
        className="uppercase text-xl font-semibold text-gray-700 ml-3"
        htmlFor="already-invoiced"
      >
        {store.type === InvoiceTypeEnum.Outgoing ? (
          <Trans>Already invoiced</Trans>
        ) : (
          <Trans>Cannot credit note</Trans>
        )}
      </label>
    </div>
  );
});
